/**
 * CSS helpers
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { isBrowser } from "@adapptio/lib-shared";

/**
 * Returns CSS property value (client only)
 *
 * @param name Variable name
 * @param element Element
 */
export function getCSSPropertyValue(name: string, element?: HTMLElement): string {
	if (isBrowser()) {
		const targetElement = element || document.documentElement;
		const value = getComputedStyle(targetElement).getPropertyValue(name);

		if (value) {
			return value.trim();
		}
	}

	return "";
}
